/** Support tickets (pages/support.tsx). */
export const support = {
  page: {
    title: "Support",
    description: "Raise an issue and track its progress with our team.",
  },

  filter: {
    allStatuses: "All statuses",
    adminTriageHint: "Admin triage: update status inline",
  },

  list: {
    errorTitle: "Couldn't load tickets",
    errorDescription:
      "Something went wrong while loading your support tickets. Check your connection and try again.",
    emptyTitle: "No tickets yet",
    emptyDescription: "Create a ticket and we'll help you out.",
    newTicket: "New ticket",
    unknownReporter: "Someone",
  },

  create: {
    title: "Create a support ticket",
    subjectLabel: "Subject",
    subjectPlaceholder: "Brief summary of the issue",
    descriptionPlaceholder:
      "Tell us what's happening, and which device or location is affected.",
    priorityLabel: "Priority",
    relatedToLabel: "Related to",
    deviceLabel: "Device",
    linkPlaceholder: "Select…",
    nothingToLink: "Nothing to link",
    submit: "Create ticket",
  },

  // Escalation to the OmniMedia platform team (author or manage.support).
  escalate: {
    action: "Escalate to OmniMedia",
    confirmTitle: "Escalate this ticket?",
    confirmDescription:
      "The OmniMedia support team will be notified and can reply directly in this thread. Escalation cannot be undone.",
    confirm: "Escalate",
    badge: "Escalated to OmniMedia",
    escalatedOn: "Escalated {date}",
    toastDone: "Ticket escalated to OmniMedia",
    toastAlready: "This ticket has already been escalated",
    toastFailed: "Could not escalate the ticket",
  },

  detail: {
    notFoundTitle: "Ticket not found",
    notFoundDescription:
      "This ticket may have been deleted or you no longer have access to it.",
    errorTitle: "Couldn't load ticket",
    errorDescription:
      "Something went wrong while loading this ticket. Check your connection and try again.",
    openedBy: "Opened by {name}",
    someone: "someone",
    relatedTo: "Related to {entity}",
    triageLabel: "Triage:",
    reporterFallback: "Reporter",
    commentAuthorFallback: "User",
    staffBadge: "Staff",
    noReplies: "No replies yet.",
    replyPlaceholder: "Write a reply…",
    reply: "Reply",
  },

  toast: {
    updated: "Ticket updated",
    updateFailed: "Could not update ticket",
    created: "Ticket created",
    createFailed: "Could not create ticket",
    subjectBodyRequired: "Subject and description are required",
    replyFailed: "Could not post reply",
    markedStatus: "Ticket marked {status}",
  },

  // Labels for the "Related to" dropdown options (linkType select).
  linkTypes: {
    none: "Nothing",
    location: "Location",
    device: "Device",
    media: "Media item",
    schedule: "Schedule",
    playback: "Playback problem",
  },

  // Capitalized entity nouns used as the linked-entity field/detail label.
  entity: {
    location: "Location",
    device: "Device",
    media: "Media",
    schedule: "Schedule",
    playback: "Playback",
  },

  ticketStatus: {
    open: "Open",
    pending: "Pending",
    resolved: "Resolved",
    closed: "Closed",
  },

  ticketPriority: {
    low: "Low",
    normal: "Normal",
    high: "High",
    urgent: "Urgent",
  },
} as const;
